var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticStyle:{"position":"relative","display":"inline-block","width":"100%"}},[_vm._t("default"),_c('span',{staticClass:"beta-badge",class:_vm.badgePositionClass},[_vm._v("Beta")])],2):_c('div',[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }